export interface IDocument {
        documentKey: string;
        fileName: string;
        fileExtension: string;
        fullFileName: string;
        documentTypeName: string;
        isArchived: boolean;
        createDate: Date;
        createBy: string;
    }

    export class Document implements IDocument {
        documentKey: string;
        fileName: string;
        fileExtension: string;
        fullFileName: string;
        documentTypeName: string;
        isArchived: boolean;
        createDate: Date;
        createBy: string;
    }
